var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6748 18.75H8.82518C4.19476 18.75 1.87955 18.75 1.02636 17.2439C0.173174 15.7379 1.35736 13.7414 3.72574 9.74847L5.65057 6.50333C7.92559 2.66778 9.06311 0.75 10.75 0.75C12.4369 0.75 13.5744 2.66777 15.8494 6.50332L17.7743 9.74846C20.1426 13.7414 21.3268 15.7379 20.4736 17.2439C19.6204 18.75 17.3052 18.75 12.6748 18.75Z",
    stroke: "#404854",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 6.75V11.25",
    stroke: "#404854",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 14.7422V14.7522",
    stroke: "#404854",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert4);
export default __webpack_public_path__ + "static/media/alert-4.43d2f0b22ebee64650c2e4907ed44f15.svg";
export { ForwardRef as ReactComponent };